import { bootstrapApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'
import { AppComponent } from './app/app.component'
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'
import {
  LicenseManager,
  ColumnMenuModule,
  StatusBarModule,
  ExcelExportModule,
} from 'ag-grid-enterprise'
import { environment } from './environment/environment'

LicenseManager.setLicenseKey(environment.aggrid.licenseKey)

ModuleRegistry.registerModules([
  AllCommunityModule,
  ColumnMenuModule,
  StatusBarModule,
  ExcelExportModule,
])

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err))
